// src/routes/AppRoutes.tsx
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import Login from '../auth/login';
import Dashboard from '../pages/dashboard';
import UserManagement from '../pages/user-management';
import GeneralContractorManagement from '../pages/general-contractor-management';
import MechanicalContractorManagement from '../pages/mechanical-contractor-management';
import MechanicalContractorDetails from '../pages/mechanical-contractor-details';
import JobSiteManagement from '../pages/jobsite-management';
import Reports from '../pages/reports';
import ReportDetails from '../pages/report-details';
import JobsiteDetails from '../pages/jobsite-details';
import JobsiteVisits from '../pages/jobsite-visits';
import ForgotPasswordPage from '../auth/forgotpassword';
import ResetPasswordPage from '../auth/reset-password';
import { ProtectedRoute } from '../components/protected-routes';
import TwoFactorVerifyPage from '../auth/2fa-verify';
import JobsiteLogs from '../components/jobsite-logs';
import ComingSoon from '../pages/comming-soon';
import CreateJobsiteVisit from '../pages/create-jobsite-visit';
import EditJobsiteVisit from '../pages/edit-jobsite-visit';
import JobsiteVisitDetails from '../pages/jobsite-visit-details';
import AddJobsite from '../pages/add-jobsite';
import EditJobsite from '../pages/edit-jobsite';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to='/login' />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/set-password" element={<ResetPasswordPage />} />
      <Route path="/two-factor-verify" element={<TwoFactorVerifyPage />} />

      <Route path="comming-soon" element={<MainLayout />}>
        <Route path="" element={<ComingSoon />} />
      </Route>

      <Route path="dashboard" element={
        <ProtectedRoute allowedRoles={['admin', 'interRepre']} redirectPath="/jobsite-management">
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<Dashboard />} />
      </Route>
      
      <Route path="user-management" element={
        <ProtectedRoute
          allowedRoles={['admin']}
          redirectPath="/jobsite-management"
        >
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<UserManagement />} />
      </Route>

      <Route path="general-contractor-management" element={
        <ProtectedRoute allowedRoles={['admin', 'organizer', 'interRepre']}>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<GeneralContractorManagement />} />
      </Route>

      <Route path="mechanical-contractor-management" element={
        <ProtectedRoute allowedRoles={['admin', 'organizer', 'interRepre']}>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<MechanicalContractorManagement />} />
        <Route path="details/:id" element={<MechanicalContractorDetails />} />
      </Route>

      <Route path="jobsite-management" element={
        <ProtectedRoute allowedRoles={['admin', 'organizer', 'interRepre']}>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<JobSiteManagement />} />
        <Route path="add-jobsite" element={<AddJobsite />} />
        <Route path="details/:id" element={<JobsiteDetails />} />
        <Route path="details/:id/logs" element={
          <ProtectedRoute allowedRoles={['admin']} redirectPath="/jobsite-management">
            <JobsiteLogs />
          </ProtectedRoute>
        } />
        <Route path="details/:id/edit" element={<EditJobsite />} />
        <Route path="details/:id/create-visit" element={<CreateJobsiteVisit />} />
        <Route path="details/:id/edit-visit/:visitId" element={
          <ProtectedRoute allowedRoles={['admin', 'organizer']} redirectPath="/jobsite-management">
            <EditJobsiteVisit />
          </ProtectedRoute>
        } />
        <Route path="visit-details/:visitId" element={<JobsiteVisitDetails />} />
      </Route>

      <Route path="reports" element={
        <ProtectedRoute allowedRoles={['admin', 'interRepre', 'organizer']} redirectPath="/jobsite-management">
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<Reports />} />
        <Route path=":id" element={<ReportDetails />} />
      </Route>

      <Route path="jobsite-visits" element={
        <ProtectedRoute allowedRoles={['admin', 'organizer', 'interRepre']}>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="" element={<JobsiteVisits />} />
      </Route>
      
    </Routes>
  );
};

export default AppRoutes;
